import routerConfig from 'srs.sharedcomponents/lib/esm/components/config/routes'

const routesConfig = {
  ...routerConfig,
  publicRoutes: {
    ...routerConfig.publicRoutes,
    '/ProductListCatalog': {
      path: [
        '/ProductListCatalog',
        '/:getLangRoute/Pages/ItemListing.aspx',
        '/en-US/Pages/ItemListing.aspx',
        '/ItemListing.aspx',
      ],
      component: 'ProductListComponent',
      pageTitle: 'txtProductList',
    },
    '/pages/esst': {
      path: [
        '/Esst',
        '/:getLangRoute/Pages/Esst.aspx',
        '/en-US/Pages/Esst.aspx',
        '/Esst.aspx',
      ],
      component: 'EsstComponent',
      pageTitle: 'headerHomeLabel',
    },
    '/ToolOrganization': {
      path: [
        '/ToolOrganization',
        '/:getLangRoute/Pages/ToolOrganization.aspx',
        '/en-US/Pages/ToolOrganization.aspx',
        '/ToolOrganization.aspx',
      ],
      component: 'MinimumStandardComponent',
      pageTitle: 'headerHomeLabel',
    },
  },
}

export default routesConfig
